import PageDTO from "@/api/commons/PageDTO";
import { assistencia24hApiNew } from "@/api/Assistencia24hApi";
import FiltroServicoDTO from "@/api/servico/FiltroServicoDTO";
import {
  FiltroServicosModel,
  FinalizarSolicitacaoModel,
} from "@/models/solicitacoes";
import { PaginationModel } from "@/models/commons/PaginationModel";
import usuarioModule from "@/store/usuario/UsuarioModule";
import moment from "moment";

class ServicoService {
  obterServicos(filtro: FiltroServicosModel) {
    // console.log(filtro);
    return assistencia24hApiNew.buscarServicosPrestador(
      new FiltroServicoDTO(
        new PageDTO(
          filtro.paginacao?.page ? filtro.paginacao?.page - 1 : 0,
          filtro.paginacao?.itemsPerPage == -1 ? 9999999: filtro.paginacao?.itemsPerPage || 5
        ),
        filtro?.status,
        filtro.dataDe,
        filtro.dataAte,
        filtro.tipoServico && filtro.tipoServico.trim().length > 0
          ? filtro.tipoServico
          : undefined,        
      )
    );
  }

  obterFotoPorIdServicoENomeArquivo(idServico:number, nomeArquivo:string) {
    return assistencia24hApiNew.obterFotoVeiculo(idServico, nomeArquivo)
  }

  obterServicoDetalhado(idServico: number) {
    return assistencia24hApiNew.obterServicoDetalhado(idServico);
  }

  aceitarSolicitacao(idServico: number, idPrestador: number, nomeDoMotorista: string, placaDoVeiculo: string, tempoEstimado: string) {
    return assistencia24hApiNew.aceitarServico({
      idServico,
      idPrestador,
      nomeDoMotorista,
      placaDoVeiculo,
      tempoEstimado
    });
  }

  reenviarSolicitacao(idServico: number, idPrestador: number, nomeDoMotorista: string, placaDoVeiculo: string, tempoEstimado: string) {
    return assistencia24hApiNew.reenviarServico({
      idServico,
      idPrestador,
      nomeDoMotorista,
      placaDoVeiculo,
      tempoEstimado
    });
  }

  recusarSolicitacao(idServico: number, idPrestador: number) {
    return assistencia24hApiNew.recusarServico({
      idServico,
      idPrestador,
    });
  }

  finalizarServico(finalizarServico: FinalizarSolicitacaoModel) {
    return assistencia24hApiNew.finalizarServico(finalizarServico);
  }

  obterQuantidadeServicos(filtro: any) {
    return assistencia24hApiNew.obterQuantidadeServicos(filtro);
  }

  administrativoCancelar(filtro: any) {
    return assistencia24hApiNew.administrativoCancelar(filtro);
  }

}

export const servicoService: ServicoService = new ServicoService();
